import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState({ storage: window.sessionStorage })],
  state: {
    token: '',
    user_id:'',
    username:''
  },
  mutations: {
    newToken: function (state, token) {
      state.token = token
    },
    newUser_id:function(state,user_id){
      state.user_id = user_id
    },
    newUsername:function(state,username){
      state.username = username
    }
  },
  actions: {
    setToken: function (context, token) {
      context.commit('newToken', token)
    },
    setUser_id: function (context, user_id) {
      context.commit('newUser_id', user_id)
    },
    setUsername: function (context, username) {
      context.commit('newUsername', username)
    }
  },
  modules: {
  },
  getters:{
    getToken: function (state) {
      return state.token
    },
    getUser_id: function (state) {
      return state.user_id
    },
    getUsername: function (state) {
      return state.username
    },
  }
})
